import { Container, Group, ScrollArea, Stack } from '@mantine/core'
import { observer } from 'mobx-react-lite'

import { NoShow } from '#components/NoShow'
import { useMst } from '#state'

import { BetaFeedbackCard } from './BetaFeedbackCard'
import { DashboardHeader } from './DashboardHeader'
import { DocumentCard } from './DocumentCard'
import { useDashboardData } from './hooks'
import { LastReleaseCard } from './LastReleaseCard'
import { PlanChangedCard } from './PlanChangedCard'
import { SpeedTestCard } from './SpeedTestCard'
import { SystemStatusCard } from './SystemStatusCard'
import { UpgradePlanCard } from './UpgradePlanCard'
import { WhatsNewCard } from './WhatsNewCard'

import styles from './Dashboard.module.css'

export const Dashboard = observer(function Dashboard() {
  const root = useMst()
  const {
    currentOrg,
    user,
    favoriteListings,
    recentListings,
    myHistoryListings,
  } = root

  const { isLoading } = useDashboardData()

  if (!(user.selectedMembership && currentOrg)) {
    return <NoShow />
  }

  const isAdmin = user.selectedMembership.isAdmin

  return (
    <ScrollArea h="100%" className={styles.scrollarea}>
      <DashboardHeader org={currentOrg} isAdmin={isAdmin} />
      <Container className={styles.wrapper} fluid pt={50} pb={50}>
        <Stack maw={1000} mx="auto" gap={30}>
          <PlanChangedCard org={currentOrg} />
          <Group
            className={styles.group}
            wrap="nowrap"
            grow
            gap={30}
            mb={0}
            mt={0}
            w="100%"
          >
            <DocumentCard
              title="My Favorites"
              folderId="favorites"
              items={favoriteListings}
              isLoading={isLoading}
              emptyState={{
                icon: 'fa-star',
                title: 'No Favorites',
                description: "You haven't favorited any documents yet.",
              }}
            />
            <DocumentCard
              title="My History"
              folderId="myHistory"
              isLoading={isLoading}
              items={myHistoryListings}
              emptyState={{
                icon: 'fa-clock',
                title: 'No Personal History',
                description: 'You have not opened any documents yet.',
              }}
            />
            <DocumentCard
              title="Workspace History"
              folderId="workspaceHistory"
              isLoading={isLoading}
              items={recentListings}
              emptyState={{
                icon: 'fa-bolt',
                title: 'No Workspace History',
                description:
                  'No documents have been edited in the last 30 days.',
              }}
            />
          </Group>
          <UpgradePlanCard org={currentOrg} />
          <WhatsNewCard />
          <Group
            className={styles.group}
            justify="center"
            grow
            gap={30}
            w="100%"
          >
            <LastReleaseCard />
            <SystemStatusCard />
            <SpeedTestCard />
          </Group>
          <BetaFeedbackCard />
        </Stack>
      </Container>
    </ScrollArea>
  )
})
